import React, { Suspense } from "react"

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CModal from "@student_components/Modal";

import AuthProvider from "@context/AuthContext";

// ** Router Import
import Router from "./router/Router"

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/legacy/build/pdf.worker.min.js',
//     import.meta.url,
// ).toString();


const App = () => {
    return (
        <Suspense fallback={null}>
            <AuthProvider >
                <ToastContainer />
                <CModal/>
                <Router />
            </AuthProvider>
        </Suspense>
    )
}

export default App
